import React from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Tooltip from 'react-bootstrap/Tooltip';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import { FaEdit } from "react-icons/fa";

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'8%'}}>ID área N1</th>
        <th style={{width:'20%'}}>Nombre área N1</th>
        <th className='d-none d-sm-table-cell' style={{width:'50%'}}>Descripción</th>
        <th style={{width:'5%'}}>{props.mode==0?'Editar':''}</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  if (props.locationsObj) {
    const rows = props.locationsObj.map((row, index) => { 
      return (      
        <tr key={index}>        
          <td>
            {row.id}
          </td>
          <td>  
            {row.nombrearea}
          </td>
          <td className='d-none d-sm-table-cell'>  
            {row.descripcionarea}
          </td>        

          <td align='center'>  
            {(props.mode==0) &&
              <Button variant='secondary'>
                <Link to = {`/editarean1page/${row.id}`}><FaEdit size={15} color='white'/></Link>      
              </Button>
              
            }
            {(props.mode==1) &&
              <Button onClick={() => {
                props.onSelected(row.id,row.nombrearea,row.descripcionarea);
                props.handleClose();
              }} variant='link' value={row.id}>Seleccionar</Button>
            } 
          </td>               
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to edit the patient.
  </Tooltip>
);



const AreasList = (props) => {        
  
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
          <TableHeader mode={props.mode} />
            <TableBody handleClose={props.handleClose} onSelected={props.onSelected} mode={props.mode} locationsObj={props.listOfAreasN1} />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

export default AreasList;